/**
 * Dogen - Digital Agency and Portfolio HTML Template
 * Author: themevillage
 **/

'use strict';

(function ($) {


  //Lenis Scroll 
  const lenis = new Lenis({
    autoRaf: true,
  });

  //Preloader
  $(window).on('load', function () {
    var $preloader = $('#preloader');
    if ($preloader.length) $preloader.hide();
    $('body').css('overflow', 'visible');
  });
  //Jarallax
  $(document).ready(function () {
    jarallax(document.querySelectorAll('.jarallax'), {
      speed: 0.5
    });
  });
  // Select navbar and offcanvas elements
  var $navOffCanvasBtn = $('.offcanvas-nav-btn');
  var $navOffCanvas = $('.navbar:not(.navbar-clone) .offcanvas-nav');
  var bsOffCanvas;

  // Function to toggle the offcanvas
  function toggleOffCanvas() {
    if (bsOffCanvas) {
      bsOffCanvas._isShown ? bsOffCanvas.hide() : bsOffCanvas.show();
    }
  }

  // Initialize offcanvas if it exists
  if ($navOffCanvas.length) {
    bsOffCanvas = new bootstrap.Offcanvas($navOffCanvas[0], { scroll: true });
    $navOffCanvasBtn.on('click', toggleOffCanvas);
  }


   //blikning effect
  let imageWrapperElement = document.querySelector(".zoom-img-wrap");
  let imageSliderElement = document.querySelector(".zoom-img-inner-wrap");
  let projectElements = gsap.utils.toArray(".zoom-inner-wrap");
  if (imageWrapperElement && imageSliderElement && projectElements.length) {
  
    let totalProjects = imageSliderElement.children.length;
    let slideMovePercent = 100 / totalProjects;
    let toggleImageWrapperVisibility = (opacityValue) => {
      gsap.to(imageWrapperElement, {
        opacity: opacityValue,
        duration: 0.5
      });
    };
    $('[data-index-number]')
      .on("mouseenter", () => toggleImageWrapperVisibility(1))
      .on("mouseleave", () => toggleImageWrapperVisibility(0))
      .on("mousemove", function () {
        let currentIndexNumber = $(this).data("index-number");
        gsap.to(imageSliderElement, {
          y: `-${slideMovePercent * currentIndexNumber}%`,
          duration: 0.6,
          ease: "power2.out"
        });
      });

    $(document).on("mousemove", ".zoom-action-wrap", function (event) {
      let { left: parentLeftOffset, top: parentTopOffset } = $(this).offset();
      gsap.to(imageWrapperElement, {
        x: event.pageX - parentLeftOffset + 50,
        y: event.pageY - parentTopOffset,
        duration: 0.5,
        ease: "power2.out"
      });
    });
  } 
  /**============================================
   * Function to handle dropdown toggle
   */
  function handleDropdownToggle(e) {
    var $dropdownToggle = $(this);
    var $submenu = $dropdownToggle.next();
    if (!$submenu.hasClass('show')) {
      $dropdownToggle.closest('.dropdown-menu').find('.show').removeClass('show');
    }
    $submenu.toggleClass('show');
    var $parentDropdown = $dropdownToggle.closest('li.nav-item.dropdown.show');
    if ($parentDropdown.length) {
      $parentDropdown.on('hidden.bs.dropdown', function () {
        $('.dropdown-submenu .show').removeClass('show');
      });
    }
    e.preventDefault();
    e.stopPropagation();
  }
  //init dropdowntoggle function
  $(document).on('click', '.dropdown-menu a.dropdown-toggle', handleDropdownToggle);

  /**============================================
   *  Sticky Menu
   */
  $(window).on('scroll', function () {
    var $stickyHeight = $('.sticky-height');
    var $headerNavWrapper = $('.header-nav-wrapper');
    if (!$headerNavWrapper.length) return;

    var headerWrapperHeight = $headerNavWrapper.outerHeight();
    var $topHeader = $('.header-top');
    var topHeaderHeight = $topHeader.length ? $topHeader.outerHeight() : 0;
    var targetScroll = topHeaderHeight + 200;

    if ($(window).scrollTop() > targetScroll) {
      $headerNavWrapper.addClass('scroll-on');
      if ($stickyHeight.length) $stickyHeight.css('height', headerWrapperHeight + 'px');
    } else {
      $headerNavWrapper.removeClass('scroll-on');
      if ($stickyHeight.length) $stickyHeight.css('height', '0');
    }
  });


  /**==========================================
   * Offcanvsa Menu
   */
  $(".canvas-menu .navbar .dropdown-toggle").append('<i class="fas fa-angle-down"></i>');
  $(".canvas-menu .submenu").before('<i class="fas fa-angle-down switcher"></i>');
  $(".vertical-menu li i.switcher").on('click', function () {
    var $submenu = $(this).next(".submenu");
    $submenu.slideToggle(300);
    $submenu.parent().toggleClass("openmenu");
  });

  $("button.burger-menu").on('click', function () {
    $(".canvas-menu").toggleClass("open");
    $(".main-overlay").toggleClass("active");
  });

  $(".canvas-menu .btn-close, .main-overlay").on('click', function () {
    $(".canvas-menu").removeClass("open");
    $(".main-overlay").removeClass("active");
  });

  const heroImages = gsap.utils.toArray(".hero-media img");
  heroImages.forEach((img, i) => {
    gsap.fromTo(img,
      {
        // Starting position: slightly shifted up
        y: -50 * (i + 1)
      },
      {
        // Ending position: shifted down (creating a large travel distance)
        y: 60 * (i + 1),
        rotation: 0,
        x: 0,
        ease: "none",
        scrollTrigger: {
          trigger: ".hero-media",
          start: "top bottom",
          end: "bottom top",
          scrub: 3,
          invalidateOnRefresh: true,
        }
      }
    );
  });

  // Initialize PureCounter
  new PureCounter({
    decimals: 0
  });

  /**==========================================
   * Scroll to Top
   */
  (function () {
    var $backBtn = $('.scroll-top');
    if ($backBtn.length) {
      $(window).on('scroll', function () {
        if ($(window).scrollTop() >= 800) {
          $backBtn.addClass('scroll-top-show');
        } else {
          $backBtn.removeClass('scroll-top-show');
        }
      });

      $backBtn.on('click', function () {
        $('html, body').animate({ scrollTop: 0 }, 600);
      });
    }
  })();

  //nice select
  $('.tv-select').niceSelect();



  /**============================================
   * FancyBox Init
   */
  if (typeof Fancybox !== 'undefined' && Fancybox.bind) {
    Fancybox.bind('[data-fancybox]', {
      Thumbs: { autoStart: false },
      Toolbar: { display: ['close'] },
      animated: true,
    });
  }

  // process card
  const cards = document.querySelectorAll('.process-card');

  cards.forEach(card => {
    card.addEventListener('mouseenter', () => {
      cards.forEach(c => c.classList.remove('active'));
      card.classList.add('active');
    });
  });

  // Function to activate middle portfolio item inside a tab-pane
  function activateMiddleItem($tabPane) {
    const $items = $tabPane.find('.portfolio-item');
    const middleIndex = Math.floor($items.length / 2);

    $items.removeClass('active');
    $items.eq(middleIndex).addClass('active');
  }

  activateMiddleItem($('.tab-pane.active'));

  $('button[data-bs-toggle="tab"]').on('shown.bs.tab', function (e) {
    const targetPane = $($(e.target).data('bs-target'));
    activateMiddleItem(targetPane);
  });

  $(document).on('mouseenter', '.portfolio-item', function () {
    $(this)
      .addClass('active')
      .siblings('.portfolio-item')
      .removeClass('active');
  });



  /**============================================
   * Product Cart Counter
   */
  $('.quantity').on('click', '.plus, .minus', function () {
    const $button = $(this);
    const $qtyInput = $button.closest('.quantity').find('.qty');

    let currentVal = parseFloat($qtyInput.val());
    let max = parseFloat($qtyInput.attr('max'));
    let min = parseFloat($qtyInput.attr('min'));
    let step = $qtyInput.attr('step');

    // Format values
    if (!currentVal || isNaN(currentVal)) currentVal = 1; // 👈 start from 1
    if (!max || isNaN(max)) max = '';
    if (!min || isNaN(min)) min = 1; // 👈 set minimum to 1
    if (step === 'any' || step === '' || step === undefined || isNaN(parseFloat(step))) step = 1;
    else step = parseFloat(step);

    const decimals = (step.toString().split('.')[1] || '').length;

    if ($button.hasClass('plus')) {
      if (max && currentVal >= max) {
        $qtyInput.val(max);
      } else {
        $qtyInput.val((currentVal + step).toFixed(decimals));
      }
    } else {
      if (currentVal <= min) {
        $qtyInput.val(min);
      } else {
        $qtyInput.val((currentVal - step).toFixed(decimals));
      }
    }
    $qtyInput.trigger('change');
  });
  // Progress Circle Animation
  const TOTAL_CIRCUMFERENCE = 188.5;
  const ANIMATION_DURATION = 1500;
  $('.progress-circle-item').each(function () {
    const $item = $(this);
    const $number = $item.find('.number');
    const $circle = $item.find('.progress-stroke');
    const targetPercentage = parseFloat($number.attr('data-target'));
    $({ Counter: 0 }).animate({ Counter: targetPercentage }, {
      duration: ANIMATION_DURATION,
      easing: 'swing',
      step: function () {
        $number.text(Math.ceil(this.Counter) + "%");
        let currentOffset = TOTAL_CIRCUMFERENCE - (TOTAL_CIRCUMFERENCE * (this.Counter / 100));
        $circle.css('stroke-dashoffset', currentOffset);
      }
    });
  });

  /**============================================
     * Pricing Tab Toggle
     */
  function tabtable_active() {
    const $elements = {
      monthly: $("#tv-nav-monthly"),
      yearly: $("#tv-nav-yearly"),
      switcher: $("#tv-switcher-input"),
      tabMonthly: $("#tv-tab-monthly"),
      tabYearly: $("#tv-tab-yearly")
    };

    const setActive = isMonthly => {
      $elements.switcher.prop("checked", isMonthly);
      $elements.monthly.toggleClass("is-active", isMonthly);
      $elements.yearly.toggleClass("is-active", !isMonthly);
      $elements.tabMonthly.toggleClass("tv-tab-hide", !isMonthly);
      $elements.tabYearly.toggleClass("tv-tab-hide", isMonthly);
    };

    [$elements.monthly, $elements.yearly].forEach($el =>
      $el.on("click", () => setActive($el.is($elements.monthly)))
    );

    $elements.switcher.on("click", () =>
      setActive(!$elements.monthly.hasClass("is-active"))
    );
  }
  if ($("#tv-nav-monthly").length) tabtable_active();

  /**============================================
   * GSAP for Title Section
   */
  let animatedTextElements = document.querySelectorAll('.sec-title');

  if (animatedTextElements.length) {
    let staggerAmount = 0.03,
      translateXValue = 20,
      delayValue = 0.1,
      easeType = "power2.out";

    animatedTextElements.forEach((element) => {
      let animationSplitText = new SplitText(element, { type: "chars, words" });
      gsap.from(animationSplitText.chars, {
        duration: 1,
        delay: delayValue,
        x: translateXValue,
        autoAlpha: 0,
        stagger: staggerAmount,
        ease: easeType,
        scrollTrigger: { trigger: element, start: "top 85%" },
      });
    });
  }

  /*========================================
  // 19. anim-zoom
  */
  if (typeof gsap !== 'undefined') {
    $('.anim-zoom').each(function () {
      // Add wrap <div>.
      $(this).wrap('<div class="zoom-wrap"></div>');

      // Add overflow hidden.
      $('.zoom-wrap').css({ overflow: 'hidden' });

      let $this = $(this);
      let $asiWrap = $this.parents('.zoom-wrap');

      if ($asiWrap.length && $this.length) {
        let tp_ZoomIn = gsap.timeline({
          scrollTrigger: {
            trigger: $asiWrap[0],
            start: 'top 100%',
            markers: false,
          },
        });
        tp_ZoomIn.from($this[0], { duration: 2, autoAlpha: 0, scale: 1.2, ease: Power2.easeOut, clearProps: 'all' });
      }
    });
  }

  const parallaxImages = document.querySelectorAll('[data-para]');
  parallaxImages.forEach(img => {
    const speed = parseFloat(img.getAttribute('data-para')) || 0.5;
    const shift = speed * 15;
    gsap.fromTo(img, {
      yPercent: -shift
    }, {
      yPercent: shift,
      ease: "none",
      scrollTrigger: {
        trigger: img.closest('.parallax-wrap'),
        start: "top bottom",
        end: "bottom top",
        scrub: 1
      }
    });
  });

  // Parallax effect for elements with data-para-reverse
  gsap.timeline({
    scrollTrigger: {
      trigger: ".video-wrapper",
      start: "top 90%",
      end: "top 30%",
      scrub: 1.2, // smooth scroll sync
    }
  })
    .to(".video-wrapper", {
      width: "100%",
      borderRadius: 0,
      ease: "power2.out"
    })
    .to(".video-bg", {
      scale: 1,
      ease: "power2.out"
    }, 0);


  /**============================================
   * GSAP fadeInUp
   */
  if ($(".fadeInUp").length > 0) {
    gsap.utils.toArray(".fadeInUp").forEach((item) => {
      let tv_fade_offset = item.getAttribute("data-fade-offset") || 40,
        tv_duration_value = item.getAttribute("data-duration") || 0.75,
        tv_fade_direction = item.getAttribute("data-fade-from") || "bottom",
        tv_onscroll_value = item.getAttribute("data-on-scroll") || 1,
        tv_delay_value = item.getAttribute("data-delay") || 0.15,
        tv_ease_value = item.getAttribute("data-ease") || "power2.out",
        tv_anim_setting = {
          opacity: 0,
          ease: tv_ease_value,
          duration: tv_duration_value,
          delay: tv_delay_value,
          x: (tv_fade_direction == "left" ? -tv_fade_offset : (tv_fade_direction == "right" ? tv_fade_offset : 0)),
          y: (tv_fade_direction == "top" ? -tv_fade_offset : (tv_fade_direction == "bottom" ? tv_fade_offset : 0)),
        };
      if (tv_onscroll_value == 1) {
        tv_anim_setting.scrollTrigger = {
          trigger: item,
          start: 'top 85%',
        };
      }
      gsap.from(item, tv_anim_setting);
    });
  }

  // Image Reveal Animation
  let revealContainers = document.querySelectorAll(".reveal");
  if (revealContainers.length) {
    revealContainers.forEach((container) => {
      let image = container.querySelector("img");

      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: container,
          toggleActions: "play none none none"
        }
      });

      tl.set(container, { autoAlpha: 1 });

      tl.from(container, {
        duration: 1,
        xPercent: -100,
        ease: Power2.out
      });

      tl.from(image, {
        duration: 1,
        xPercent: 100,
        scale: 1,
        delay: -1,
        ease: Power2.out
      });
    });
  }

  /**============================================
   * Image zoom gsap
   */
  document.querySelectorAll(".scale-up-img").forEach((section) => {
    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: "top bottom",
        end: "bottom center",
        scrub: 1,
        markers: false,
      },
    });

    tl.to(section.querySelector(".scale-up"), {
      scale: 1.15,
      duration: 1,
    });
  });

  /* 
**********************************
Masionry Grid with Isotope
********************************** 
*/
  if ($(".grid-container")?.length) {
    $(".grid-container").imagesLoaded(function () {
      var $grid = $(".grid-container").isotope({
        itemSelector: ".grid-container .grid-item",
        percentPosition: true,
        layoutMode: "fitRows",
      });

      // filter items on button click
      $(".btn-filter-wrap").on("click", "button", function () {
        $(".btn-filter-wrap button").removeClass("active");
        $(this).addClass("active");

        var filterValue = $(this).attr("data-filter");
        $grid.isotope({ filter: filterValue });
      });
    });
  }

  /**============================================
 * GSAP 3D Scale Animation
 */
  let portfolioLists = gsap.utils.toArray(".scale-3d");

  if (portfolioLists.length > 0) {
    portfolioLists.forEach((portfolio) => {
      gsap.set(portfolio, {
        opacity: 0.8,
        transform: "perspective(1500px) translate3d(0, 0, 0) rotateX(40deg) scale(0.8)"
      });

      let t1 = gsap.timeline();

      t1.set(portfolio, { position: "relative" });

      t1.to(portfolio, {
        scrollTrigger: {
          trigger: portfolio,
          scrub: 1.5,
          start: "top bottom",
          end: "bottom center",
        },
        scale: 1,
        rotateX: 0,
        opacity: 1,
        duration: 1.2,
        ease: "power2.out"
      });
    });
  }


  /**==========================================
   * Offcanvas Menu
   */

  const menuToggle = document.getElementById("menuToggle");
  const menuClose = document.getElementById("menuClose");
  const primaryMenu = document.getElementById("fullscreenMenu");

  if (!primaryMenu) return;
  const bg = primaryMenu.querySelector(".menu-bg");
  const items = primaryMenu.querySelectorAll(".main-menu > li");

  let isMenuOpen = false;

  // GSAP TIMELINE
  const menuTL = gsap.timeline({
    paused: true,
    defaults: { ease: "power4.inOut" },
    onStart: () => {
      primaryMenu.style.visibility = "visible";
      primaryMenu.style.pointerEvents = "auto";
    },
    onReverseComplete: () => {
      primaryMenu.style.visibility = "hidden";
      primaryMenu.style.pointerEvents = "none";
    }
  });

  if (bg) {
    menuTL.fromTo(
      bg,
      { scaleY: 0, opacity: 0, transformOrigin: "top" },
      { scaleY: 1, opacity: 1, duration: 0.9 },
      0
    );
  }

  menuTL.fromTo(
    ".menu-close",
    { opacity: 0, rotate: -90 },
    { opacity: 1, rotate: 0, duration: 0.4 },
    "-=0.4"
  );

  if (items.length) {
    menuTL.fromTo(
      items,
      { y: 50, opacity: 0 },
      { y: 0, opacity: 1, stagger: 0.12, duration: 0.6 },
      "-=0.3"
    );
  }

  // OPEN menu
  if (menuToggle) {
    menuToggle.addEventListener("click", () => {
      if (isMenuOpen) return;

      isMenuOpen = true;

      gsap.set(menuToggle, { pointerEvents: "none" });
      gsap.to(menuToggle, { opacity: 0, duration: 0.2 });

      menuTL.play(0);
    });
  }

  // CLOSE menu
  if (menuClose) {
    menuClose.addEventListener("click", () => {
      if (!isMenuOpen) return;

      isMenuOpen = false;

      menuTL.reverse();

      menuTL.eventCallback("onReverseComplete", () => {
        primaryMenu.style.visibility = "hidden";
        primaryMenu.style.pointerEvents = "none";

        if (menuToggle) {
          gsap.to(menuToggle, {
            opacity: 1,
            duration: 0.3,
            pointerEvents: "auto"
          });
        }
      });
    });
  }
  // Dropdown Menu
  $('.fullscreen-menu .has-dropdown > a').on('click', function (e) {
    e.preventDefault();

    const parent = $(this).parent();

    parent.toggleClass('active');
    parent.children('.sub-menu').slideToggle(350);

    parent.siblings('.has-dropdown')
      .removeClass('active')
      .children('.sub-menu')
      .slideUp(350);
  });

	



})(jQuery);
